import { render, staticRenderFns } from "./ItemTableViewComponent.vue?vue&type=template&id=1314f795"
import script from "./ItemTableViewComponent.vue?vue&type=script&lang=js"
export * from "./ItemTableViewComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1314f795')) {
      api.createRecord('1314f795', component.options)
    } else {
      api.reload('1314f795', component.options)
    }
    module.hot.accept("./ItemTableViewComponent.vue?vue&type=template&id=1314f795", function () {
      api.rerender('1314f795', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/data-platform/modules/principal_search/components/ItemTableViewComponent.vue"
export default component.exports